// src/widgets/moderation/CategoryQuickStats/CategoryQuickStats.tsx
import React from 'react';
import { Badge } from '../Badge/Badge';
import { Card } from '../Card/Card';
import './CategoryQuickStats.scss';

type Severity = 'high' | 'medium' | 'low';

export type CategoryStatItem = {
  label: string; // "Drugs"
  count: number;
  restriction?: number; // 32
  severity: Severity;
};

type Props = {
  total: number;
  items: CategoryStatItem[];
  onChipClick?: (restriction?: number) => void;
};

const severityToVariant = (s: Severity) => {
  if (s === 'high') return 'danger';
  if (s === 'medium') return 'warning';
  return 'info';
};

export const CategoryQuickStats: React.FC<Props> = ({ total, items, onChipClick }) => {
  return (
    <Card
      className="md-quick"
      title="Queue Quick Stats"
      rightSlot={<Badge text={`TOTAL ${total}`} variant="default" />}
    >
      <div className="md-quick__row">
        {items.map((item) => {
          const percent = total > 0 ? Math.round((item.count / total) * 100) : 0;

          return (
            <button
              key={item.label}
              className="md-quick__chip"
              type="button"
              onClick={() => onChipClick?.(item.restriction)}
            >
              <div className="md-quick__chip-left">
                <span className={`md-quick__dot md-quick__dot--${item.severity}`} />
                <span className="md-quick__name">{item.label}</span>
              </div>

              <div className="md-quick__chip-right">
                <span className="md-quick__count">{item.count}</span>
                <Badge text={`${percent}%`} variant={severityToVariant(item.severity)} />
              </div>
            </button>
          );
        })}
      </div>
      <div className="md-quick__hint">Click a chip to filter the queue.</div>
    </Card>
  );
};
